<div class="no-assignment-content">
    <div class="title">
        <img [src]="exclaimIcon" alt="Exclamation" class="exclaim-icon">
        No Project Assignment
    </div>
    <div class="no-assignment-text">There are no active projects currently mapped to you</div>
    <div class="suggestion-text">Kindly contact your administrator for further assistance.</div>
    <div class="actions">
      <!-- <button class="btn secondary" (click)="refreshPage()">Refresh</button> -->
      <button class="btn primary" (click)="logout()">Logout</button>
    </div>
</div>
